import { Meta } from '@angular/platform-browser';
import { Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class BaseComponent {
  bodyClass = '';
  // pageCategory = 'Home';
  // categoryURL = '/';
  pageTitle = 'The Original Farmers Market';
  pageURL = 'http://www.farmersmarketla.com/';
  pageImage = 'http://www.farmersmarketla.com/images/fb-og-image.jpg';
  pageDescription = 'A favorite destination among locals and tourists since 1934, LA\'s world famous Original Farmers Market offers over 100 gourmet grocers, restaurants from across the globe, and world class shopping in an open-air setting.';
  pageKeywords = 'Farmers Market Los Angeles,  The Original Farmers Market, 3rd and Fairfax,  Gourmet Groceries, Best Grocery Store, Top Tourist Destination, Best Tourist Attraction, Best Farmers Market LA, Best Shopping, Best Dining, Meet Me at Third and Fairfax, historic Farmers Market, Farmers Market Clock Tower, Old Farmers Market in LA, Farmers Market next to the Grove.';
  renderer: Renderer2;
  hideHeader = false;
  hideFooter = false;

  constructor(private meta: Meta,
              private rendererFactory: RendererFactory2,
              @Inject(DOCUMENT) private document: Document) {

    this.renderer = rendererFactory.createRenderer(null, null);
  }

  updatePageInfo(data: {
    bodyClass?: string,
    pageCategory?: string,
    categoryURL?: string,
    pageTitle?: string,
    pageURL?: string,
    pageImage?: string,
    pageDescription?: string,
    pageKeywords?: string,
    showHeader: boolean,
    showFooter: boolean
  }) {
    // console.log('updatePageInfo(): ', data);

    const keys = Object.keys(data);
    if (keys.indexOf('bodyClass') !== -1) {
      // console.log('bodyClass', this.bodyClass, data.bodyClass);
      if (!!this.bodyClass) {
        this.renderer.removeClass(this.document.body, this.bodyClass);
      }
      if (!!data.bodyClass && data.bodyClass !== '') {
        this.bodyClass = data.bodyClass;
        this.renderer.addClass(this.document.body, data.bodyClass);
      }
    }
    // if (keys.indexOf('pageCategory')) {
    //   this.pageCategory = data.pageCategory;
    // }
    // if (keys.indexOf('categoryURL')) {
    //   this.categoryURL = data.categoryURL;
    // }

    // this.meta.removeTag('og:title');
    // this.meta.removeTag('twitter:title');
    // this.meta.removeTag('og:image');
    // this.meta.removeTag('twitter:image');
    // this.meta.removeTag('og:description');
    // this.meta.removeTag('description');

    if (keys.indexOf('pageTitle') !== -1) {
      this.pageTitle = data.pageTitle;
      this.document.title = data.pageTitle;
      this.meta.updateTag({ name: 'og:title', content: data.pageTitle });
      this.meta.updateTag({ name: 'twitter:title', content: data.pageTitle });
    }
    if (keys.indexOf('pageURL') !== -1) {
      this.pageURL = data.pageURL;
      this.meta.updateTag({ name: 'og:url', content: data.pageURL });
    }
    if (keys.indexOf('pageImage') !== -1) {
      this.pageImage = data.pageImage;
      this.meta.updateTag({ name: 'og:image', content: data.pageImage });
      this.meta.updateTag({ name: 'twitter:image', content: data.pageImage });
    }
    if (keys.indexOf('pageDescription') !== -1) {
      this.pageDescription = data.pageDescription;
      this.meta.updateTag({ name: 'og:description', content: data.pageDescription });
      this.meta.updateTag({ name: 'description', content: data.pageDescription });
    }
    if (keys.indexOf('pageKeywords') !== -1) {
      this.pageKeywords = data.pageKeywords;
      this.meta.updateTag({ name: 'keywords', content: data.pageKeywords });
    }

    this.showHeader(data.showHeader);
    this.showFooter(data.showFooter);
  }

  showHeader(showHeader: boolean) {
    this.hideHeader = !showHeader;
    // console.log('hiding header', this.hideHeader);
  }

  showFooter(showFooter: boolean) {
    this.hideFooter = !showFooter;
    // console.log('hiding footer', this.hideFooter);
  }
}
